import React from 'react';
import C from '../colors';

const Empty = ({ message, minHeight = 400, children }) => (
  <div style={{
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    minHeight, padding: '40px 24px', textAlign: 'center',
  }}>
    <div style={{ fontFamily: C.serif, fontSize: 28, color: C.ink3, marginBottom: children ? 16 : 0 }}>
      {message}
    </div>
    {children}
  </div>
);

export default Empty;
